/** Privacy lifecycle for browser billing-profile drafts and unresolved creates.
 * Only owned financial namespaces are inspected. Call with a known user after
 * authentication, or null for explicit sign-out; never during token refresh or
 * while initial session discovery is pending. Cleanup failures are not ignored. */

/** Minimal browser storage boundary also permits deterministic failure testing. */
export interface BillingDraftStorage {
 readonly length:number;key(index:number):string|null;getItem(key:string):string|null;removeItem(key:string):void;
}
/** Exact namespaces keep financial draft cleanup separate from unrelated app data. */
const PREFIXES=['miraops.pending.billingProfile.','miraops.draft.billingProfile.','miraops.pending.invoiceDelivery.','miraops.pending.invoicePayment.','miraops.draft.invoicePayment.','miraops.pending.invoiceReversal.','miraops.draft.invoiceReversal.','miraops.pending.invoiceEvidence.','miraops.pending.receiptAllocation.','miraops.draft.receiptAllocation.'] as const;
/** A valid person identity is required before retaining scoped private values. */
const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Remove foreign or malformed billing records, or all billing records on logout.
 * Snapshot keys before removal to avoid skipping entries as Storage indices move.
 * A thrown failure means callers must not open the private creation form yet. */
export function clearForeignBillingDrafts(storage:BillingDraftStorage,currentUser:string|null):number{
 if(currentUser!==null&&!UUID.test(currentUser))throw Error('invalid_billing_user');
 const remove:string[]=[];
 for(let index=0;index<storage.length;index++){
  const name=storage.key(index);if(name===null)continue;
  const prefix=PREFIXES.find(value=>name.startsWith(value));if(!prefix)continue;
  const parts=name.slice(prefix.length).split('.');
  const valid=parts.length===3&&UUID.test(parts[0]??'')&&UUID.test(parts[1]??'')
   &&(parts[2]==='issuer'||UUID.test(parts[2]??''));
  if(currentUser===null||!valid||parts[0]?.toLowerCase()!==currentUser.toLowerCase())remove.push(name);
 }
 for(const name of remove){storage.removeItem(name);if(storage.getItem(name)!==null)throw Error('billing_draft_cleanup_failed');}
 return remove.length;
}
